angular.module('graph').controller('ph-feed-ctrl', [
    '$scope',
    'ph-core',
    'ph-paging',
    'ph-broadcast',
    '$timeout',
    '$rootScope',
    'fxScrollFactory',
    function(
        $scope,
        $core,
        $paging,
        $broadcast,
        $timeout,
        $root,
        $fxScroll
    ) {
        $scope.attach = {
            'photo' : function (id) {
                $scope.attach.trigger(id, 'photo')
            },
            'document' : function (id) {
                $scope.attach.trigger(id, 'document')
            },
            'trigger' : function (id, type) {
                document.getElementById('input-attach-' + type + '-' + id).click()
            }
        };

        $scope.di = {
            'documents' : 'document',
            'photos'    : 'photo',
            'links'     : 'link'
        };

        $scope.input = {
            'photo'    : new Array,
            'document' : new Array
        };

        $scope.fn       = {
            "templating" : function(data) {
                var temp = {
                    'content'   : '',
                    'privacy'   : 'public',
                    'groups'    : new Array,
                    'photos'    : new Array,
                    'documents' : new Array,
                    'links'     : new Array,
                    'new'       : {
                        'photos'    : new Array,
                        'documents' : new Array,
                        'links'     : new Array
                    },
                    'trash'     : {
                        'photos'    : new Array,
                        'documents' : new Array,
                        'links'     : new Array
                    },
                    'locks'     : 0
                };

                return Object.assign(temp, data);
            },
            "forest" : function(data) {
                return {
                    'content'   : data.content,
                    'privacy'   : data.privacy,
                    'groups'    : data.groups,
                    'photos'    : data.photos
                        .map(function(e) {
                            return e.id
                        }),
                    'documents' : data.documents
                        .map(function(e) {
                            return e.id
                        }),
                    'links'     : data.links
                        .map(function(e) {
                            return e.id
                        }),
                };
            },
            "publish"    : function() {
                if ($scope.buffer[0].locks > 0)
                    return;

                if ($scope.buffer[0].privacy === 'public' && $scope.filters.state === true)
                    $scope.buffer[0].groups = $scope.filters.groups;

                $core.post('/xhr/' + make('entry') + 'feed', $scope.fn.forest($scope.buffer[0])).then(function(response) {
                    if (response.data.state === 0) {

                        var $post = response.data.data;

                        $scope.posts.unshift($post);

                        $scope.states[$post.id] = 'read';

                        $scope.filters.state = false;

                        /**
                         *
                         */
                        $broadcast.emit('join:post', [response.data.data.id]);

                        //
                        $scope.buffer[0] = $scope.fn.templating();

                        window.scrollTo(0, 0);
                    } else {
                        $root.$broadcast('ph-modal-show', response.data.data.content);
                    }
                });
            },
            "modificate" : function(id, $post, key) {
                // angular.copy($scope.buffer[id], $scope.posts[]);
                angular.copy();
                $scope.buffer[id] = $scope.fn.templating($post);
                $scope.states[id] = 'modify';
            },
            "update"    : function(id, $post, key) {
                if ($scope.buffer[id].locks > 0)
                    return;

                for (var type in $scope.buffer[id].trash) {
                    var attach = $scope.buffer[id].trash[type];

                    if (attach.length > 0){
                        attach.forEach(function (item) {
                            var detach = $scope.fn.detaching[
                                $scope.di[type]
                                ];
                            detach(0, item, 0);
                        });
                    }
                }

                $core.post('/xhr/post/' + id, $scope.fn.forest($scope.buffer[id])).then(function(response) {
                    if (response.data.state === 0) {
                        $scope.posts[key] = Object.assign(
                            $scope.posts[key], $scope.buffer[id]
                        );

                        $scope.states[$post.id] = 'read';

                        delete $scope.buffer[id];
                    } else {
                        $root.$broadcast('ph-modal-show', response.data.data.content);
                    }
                });
            },
            "canceling"  : function($post, key) {
                if ($scope.buffer[$post.id].locks > 0)
                    return;

                for (var type in $scope.buffer[$post.id].new) {
                    var attach = $scope.buffer[$post.id].new[type];

                    if (attach.length > 0){
                        attach.forEach(function (item) {
                            var index = $scope.buffer[$post.id][type].indexOf(item);
                            if (index !== -1)
                                $scope.buffer[$post.id][type].splice(index, 1);
                            var detach = $scope.fn.detaching[
                                $scope.di[type]
                                ];
                            detach(0, item, 0);
                        });
                    }
                }

                for(var type in $scope.buffer[$post.id].trash) {
                    var trash = $scope.buffer[$post.id].trash[type];

                    if (trash.length > 0) {
                        trash.forEach(function (item) {
                            $scope.posts[key][type].push(item);
                        });
                    }
                }

                $scope.states[$post.id] = 'read';

                delete $scope.buffer[$post.id];
            },
            "deletion"  : function($post) {

            },
            "delete"    : function(id, key) {
                $core.delete('/xhr/post/' + id)
                    .then(function ($response) {
                        if ($response.data.state === 0) {
                            $scope.posts.splice(key, 1);
                        }
                    })
            },
            "attaching"  : {
                "photo"       : function(id) {
                    $scope.buffer[id].locks++;
                    $core.post(
                        '/xhr/post/' + id + '/photos',
                        {
                            name    : $scope.input.photo[id].name,
                            photo   : $scope.input.photo[id].base
                        }
                    ).then(function(response) {
                        $scope.buffer[id].locks--;
                        if (response.data.state === 0) {
                            var $photo = response.data.data;
                            var exists = false;

                            for (var px in $scope.buffer[id].photos) {
                                var photo = $scope.buffer[id].photos[px];

                                if (photo.id === $photo.id) {
                                    exists = true;
                                    break;
                                }
                            }

                            if (exists === false) {
                                $scope.buffer[id].photos.push(
                                    $photo
                                );

                                $scope.buffer[id].new.photos.push(
                                    $photo
                                );
                            }
                        } else {
                            $root.$broadcast('ph-modal-show', response.data.data.photo);
                        }
                    });
                },
                "document"    : function(id) {
                    if ($scope.input.document[id].size === 0)
                        $root.$broadcast('ph-modal-show', 'You cant load empty file');
                    else {
                        $scope.buffer[id].locks++;
                        console.log($scope.buffer[id].locks, id);
                        $core.post(
                            '/xhr/post/' + id + '/documents',
                            {
                                name        : $scope.input.document[id].name,
                                document    : $scope.input.document[id].base
                            }
                        ).then(function(response) {
                            $scope.buffer[id].locks--;
                            if (response.data.state === 0) {
                                var $document = response.data.data;
                                var exists = false;

                                for (var dx in $scope.buffer[id].documents) {
                                    var document = $scope.buffer[id].documents[dx];

                                    if (document.id === $document.id) {
                                        exists = true;
                                        break;
                                    }
                                }

                                if (exists === false) {
                                    $scope.buffer[id].documents.push(
                                        $document
                                    );

                                    $scope.buffer[id].new.documents.push(
                                        $document
                                    );
                                }
                            } else {
                                $root.$broadcast('ph-modal-show', response.data.data.document);
                            }
                        });
                    }
                },
                "link"    : function($event, id) {
                    var part = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)(.*)?(#[\w\-]+)*\/?$/;

                    var clip = $event.originalEvent.clipboardData;

                    var url = clip ? clip.getData('text/plain') : angular.element(
                        $event.currentTarget
                    ).val();

                    var exists = false;

                    for (var index = 0; index < $scope.buffer[id].links.length; index++) {
                        if ($scope.buffer[id].links[index].address === url) {
                            exists = true;
                            break;
                        }
                    }

                    if (part.test(url) && exists === false) {
                        $scope.buffer[id].locks++;
                        $core.post('/xhr/post/attach/link', {
                            link: url
                        }).then(function(response) {
                            $scope.buffer[id].locks--;
                            if (response.data.state === 0) {
                                $scope.buffer[id].links.push(
                                    response.data.data
                                );
                            } else {
                                $root.$broadcast('ph-modal-show', response.data.data.link);
                            }
                        });
                    }
                }
            },
            "detaching": {
                "photo": function(id, $photo, key) {
                    if (id === 0)
                        $scope.buffer[id].photos.splice(key, 1);
                    else if ($scope.buffer[id].trash.photos.indexOf($photo) === -1) {
                        $scope.buffer[id].photos.splice(key, 1);
                        $scope.buffer[id].trash.photos.push($photo);
                    }
                },
                "document": function(id, $document, key) {
                    if (id === 0)
                        $scope.buffer[id].documents.splice(key, 1);
                    else if ($scope.buffer[id].trash.documents.indexOf($document) === -1) {
                        $scope.buffer[id].documents.splice(key, 1);
                        $scope.buffer[id].trash.documents.push($document);
                    }
                },
                "link": function(id, $link, key) {
                    $scope.buffer[id].links.splice(key, 1);
                }
            },
            "like"     : function($post) {
                $core.post('/xhr/post/' + $post.id + '/likes')
                    .then(function($response) {
                        if ($response.data.state === 0) {
                            ++$post.likes; $post.liked = true;
                        }
                    });
            },
            "unlike"     : function($post) {
                $core.delete('/xhr/post/' + $post.id + '/likes')
                    .then(function(response) {
                        if (response.data.state === 0) {
                            --$post.likes; $post.liked = false;
                        }
                    });
            },
            "comment" : function($post) {
                $core.post('/xhr/post/' + $post.id + '/comments')
                    .then(function(response) {
                        if (response.data.state === 0) {
                            // --$post.likes; $post.liked = false;
                        }
                    });
            }
        };

        $scope.buffer = new Object;
        $scope.states = new Object;

        $scope.buffer[0] = $scope.fn.templating();

        $scope.filters = {
            "state"  : false,
            "groups" : new Array
        };

        $scope.$paging      = $paging.new();
        $scope.posts        = [];
        $scope.entry        = null;
        $scope.loader       = 1;
        $scope.entry_id     = 0;
        $scope.query        = $core.$uri.$query.new({
            page    : 0,
            let     : 0,
        });

        $scope.$on('ph-root-feed-update', function($e, $query) {
            $scope.$paging  = $paging.new();

            ++$scope.$paging.page;

            $query.set('page', 0).set('let', 0);

            $scope.query = $query;

            $scope.posts = [];

            $fxScroll.renew('posts');

            $scope.find();
        });

        $scope.init = function ($name, $id) {
            if ($name) $scope.entry  = $name === null ? 'user' : $name;
            if ($id) $scope.entry_id = $id;

            if ($name === null)
                $broadcast.emit('join:feed');

            $scope.find();
        };

        $scope.$entry   = function($name, $id) {
            $scope.entry    = $name === null ? 'user' : $name;
            $scope.entry_id = $id;

            if ($name === null)
                $broadcast.emit('join:feed');
        };

        function make(state)
        {
            if (state === 'entry') {
                var $entry = $scope.entry !== 'user' ? $scope.entry + '/' : '';
                    $entry += $scope.entry_id !== 0 ? $scope.entry_id + '/' : '';

                return $entry;
            }

        }

        $scope.publish  = function() {
            if ($scope.post['groups'])
                delete $scope.post['groups'];

            if ($scope.post.privacy === 'public' && $scope.filters.state === true)
                $scope.post['groups'] = $scope.filters.groups;

            $scope.filters.state = false;

            $core.post('/xhr/' + make('entry') + 'feed', $scope.post).then(function($response) {
                if ($response.data.state === 0) {
                    $scope.posts.unshift($response.data.data);
                    /**
                     *
                     */
                    $broadcast.emit('join:post', [$response.data.data.id]);

                    $scope.post     = {
                        "content"     : '',
                        "privacy"     : 'public',
                        "photos"      : new Array,
                        "documents"   : new Array,
                        "link"        : new Array
                    };

                    //
                    $scope.buffer = {
                        "photos"     : new Array,
                        "documents"  : new Array,
                        "link"       : new Array
                    };
                }
            });
        };

        $scope.delete = function($id) {
            $core.delete('/xhr/post/' + $id).then(function($response) {
                // console.log($response);
            });
        };

        $scope.find     = function(next) {
            //if ($scope.$paging.pages > -1 && $scope.$paging.pages === $scope.$paging.page)
            //    return;

            var page = $scope.query.get('page');

            $scope.query.set(
                'page', +(++page)
            );

            $core.get('/xhr/' + make('entry') + 'feed?' + $scope.query.str())
                .then(function($response) {
                    if ($response.data.state === 0 && $response.data.data.length > 0) {
                        $scope.$paging.pages = $response.data.pages;
                        $scope.$paging.page = $response.data.page;

                        var connect = [];

                        /**
                         *
                         */
                        for (var i = 0; i < $response.data.data.length; i++) {
                            $scope.states[$response.data.data[i].id] = 'read';
                            connect.push($response.data.data[i].id);
                        }

                        /**
                         *
                         */
                        $broadcast.emit('join:post', connect);

                        /**
                         *
                         */
                        $scope.posts = $scope.posts.concat(
                            $response.data.data
                        );

                        if (next) next();
                    }
                    $scope.loader = 0;
                });
        };

        /**
         *
         */
        $broadcast.on('post:publish', function($data, $guid) {
            if ($core.$guid !== $guid) {
                if ($scope.entry === $data.entry.place.location && $scope.entry_id === $data.entry.place.id) {
                    ++$scope.$paging.let;

                    /**
                     * 
                     */
                    $scope.posts.unshift($data.entry);

                    /**
                     *
                     */
                    $scope.states[$data.entry.id] = 'read';

                    /**
                     *
                     */
                    $broadcast.emit('join:post', [$data.entry.id]);

                }
            }
        });

        /**
         *
         */
        $broadcast.on('post:likes:like', function($data, $guid) {
            if ($core.$guid !== $guid) {
                $core.$array.find($scope.posts, $data['entry'].id, function(post, key) {
                    ++$scope.posts[key].likes;
                    $scope.$digest();
                }, function() {
                    // console.log('not found');
                });
            }
        });

        /**
         *
         */
        $broadcast.on('post:likes:unlike', function($data, $guid) {
            if ($core.$guid !== $guid) {
                $core.$array.find($scope.posts, $data['entry'].id, function(post, key) {
                    --$scope.posts[key].likes;
                    $scope.$digest();
                }, function() {
                    // console.log('not found');
                });
            }
        });

        /**
         *
         */
        $broadcast.on('me:post:likes:like', function($data, $guid) {
            if ($core.$guid !== $guid) {
                $core.$array.find($scope.posts, $data['entry'].id, function(post, key) {
                    $scope.posts[key].liked = true;
                    $scope.$digest();
                }, function() {
                    // console.log('not found');
                });
            }
        });

        /**
         *
         */
        $broadcast.on('me:post:likes:unlike', function($data, $guid) {
            if ($core.$guid !== $guid) {
                $core.$array.find($scope.posts, $data['entry'].id, function(post, key) {
                    $scope.posts[key].liked = false;
                    $scope.$digest();
                    $scope.$digest();
                }, function() {
                    // console.log('not found');
                });
            }
        });

        /**
         *
         */
        $broadcast.on('post:comments:publish', function($data, $guid) {
            $core.$array.find($scope.posts, $data['entry'].id, function(post, key) {
                ++$scope.posts[key].comments;
                $scope.$digest();
            }, function() {
                // console.log('not found');
            });
        });

        /**
         *
         */
        $broadcast.on('post:comments:delete', function($data, $guid) {
            $core.$array.find($scope.posts, $data['entry'].id, function(post, key) {
                --$scope.posts[key].comments;
                $scope.$digest();
            }, function() {
                // console.log('not found');
            });
        });
    }
]);

angular.module('graph').controller('ph-read-feed-tab', [
    '$scope', '$controller', '$rootScope', 'ph-touch-service', 'ph-broadcast',
    function ($scope, $controller, $root, $phtouch, $broadcast) {
        angular.extend(this, $controller('ph-feed-ctrl', {$scope: $scope}));

        var $module = 'ph-read-feed-tab';

        $phtouch.$watch($scope, $module, function () {
            $phtouch.$touch($module, function () {
                $scope.init();
            });
        });
    }
]);